import React,{useRef } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar ,getElementAtEvent } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
);

const QuestionChart = ({ data,onQuestionClick }) => {
  const chartRef = useRef(null);
  const chartData = {
    labels: data.map((item) => item.Labels),
    datasets: [
      {
        label: "Average Correct %",
        data: data.map((item) => item.Percetage),
        backgroundColor: "#7C4DFF",
        borderRadius: 6,
        borderSkipped: false,
        // barPercentage: 0.5,
        categoryPercentage: 0.5,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 18,
          usePointStyle: false,
          font: {
            size: 14,
            weight: "600",
          },
        },
      },

      // tooltip: {
      //   callbacks: {
      //     label: (context) => `${context.raw}%`,
      //   },
      // },
      
    },

    scales: {
      x: {
        grid: {
          display: false,
        },

        ticks: {
          color: "#555",
          font: {
            size: 13,
          },
        },
      },

      y: {
        beginAtZero: true,
        max: 100,

        ticks: {
          stepSize: 10,
          callback: (value) => `${value}`,
          color: "#666",
        },

        grid: {
          color: "#E5E7EB",
        },
      },
    },

    animation: {
      duration: 1000,
    },
  };

  const valuePlugin = {
    id: "valuePlugin",

    afterDatasetsDraw(chart) {
      const { ctx } = chart;

      chart.data.datasets.forEach((dataset, i) => {
        const meta = chart.getDatasetMeta(i);

        meta.data.forEach((bar, index) => {
          ctx.save();

          ctx.fillStyle = "#4B5563";
          ctx.font = "bold 12px Arial";
          ctx.textAlign = "center";

          ctx.fillText(
            `${dataset.data[index]}%`,
            bar.x,
            bar.y - 10
          );

          ctx.restore();
        });
      });
    },
  };

const handleChartClick = (event) => {
  const chart = chartRef.current;

  if (!chart) return;

  const elements = chart.getElementsAtEventForMode(
    event.nativeEvent,
    "nearest",
    { intersect: true },
    true
  );

  if (elements.length > 0) {
    const index = elements[0].index;
    console.log(data[index].Labels);
    onQuestionClick(data[index].Labels);
  }
};
  return (
    <div style={{ height: "300px", width: "96%" }}>
      <Bar ref={chartRef} onClick={handleChartClick}
        data={chartData}
        options={options}
        plugins={[valuePlugin]}
      />
    </div>
  );
};

export default QuestionChart;